export function initForm() {
  const form = document.getElementById('contact-form');
  if (!form) return;

  const successBanner = document.getElementById('form-success-banner');

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function validateUrl(url) {
    if (!url) return true; // Optional or validate if provided
    try {
      const parsed = new URL(url.startsWith('http') ? url : `https://${url}`);
      return parsed.hostname.includes('.');
    } catch {
      return false;
    }
  }

  function showError(fieldId, message) {
    const group = document.getElementById(fieldId)?.closest('.form-group');
    if (!group) return;
    group.classList.add('has-error');
    const errorElem = group.querySelector('.form-error');
    if (errorElem) errorElem.textContent = message;
  }

  function clearError(fieldId) {
    const group = document.getElementById(fieldId)?.closest('.form-group');
    if (!group) return;
    group.classList.remove('has-error');
  }

  function validateField(input) {
    const id = input.id;
    const val = input.value.trim();

    clearError(id);

    if (input.required && !val) {
      showError(id, 'Este campo es obligatorio.');
      return false;
    }

    if (id === 'email' && val && !validateEmail(val)) {
      showError(id, 'Ingresa un correo electrónico válido (ej. nombre@empresa.com).');
      return false;
    }

    if (id === 'website' && val && !validateUrl(val)) {
      showError(id, 'Ingresa una URL válida (ej. tuempresa.com).');
      return false;
    }

    if (id === 'message' && val && val.length < 10) {
      showError(id, 'Describe tu proyecto en al menos 10 caracteres.');
      return false;
    }

    return true;
  }

  // Realtime blur / input handlers
  const inputs = form.querySelectorAll('input, select, textarea');
  inputs.forEach(input => {
    input.addEventListener('blur', () => validateField(input));
    input.addEventListener('input', () => {
      if (input.closest('.form-group').classList.contains('has-error')) {
        validateField(input);
      }
    });
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    let isValid = true;

    inputs.forEach(input => {
      if (!validateField(input)) {
        isValid = false;
      }
    });

    if (isValid) {
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Enviando Datos...';
      }

      setTimeout(() => {
        form.reset();
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Solicitar Diagnóstico Data-Driven';
        }
        if (successBanner) {
          successBanner.style.display = 'block';
          successBanner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 1000);
    }
  });
}
